import React, { useState, useEffect } from "react";
import { bool, func, instanceOf } from "prop-types";
import { actions as depositsActions, selectors as depositsSelectors } from "reducers/deposits";
import Drawer from "pages/_components/Drawer/Drawer";

import HistoricalDepositsFilter from "pages/deposits/_components/HistoricalDepositsFilter";
import CustomData from "pages/_components/CustomData/CustomData";
import GridTable from "pages/_components/GridTable/GridTable";
import I18n from "pages/_components/I18n";
import Image from "pages/_components/Image";
import { connect, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import * as i18n from "util/i18n";
import { getLimitDate } from "util/date";
import moment from "moment";
import EmptyScreenAlert from "pages/_components/EmptyScreenAlert/EmptyScreenAlert";
import FilterTags from "./FilterTags";

const HistoricalList = (props) => {
    const { historicalDeposits, isDesktop, dispatch } = props;
    const { filters } = useSelector((state) => state.deposits);
    const noFilter =
        !filters.account &&
        !filters.creationDateFrom &&
        !filters.creationDateTo &&
        !filters.depositType &&
        moment(filters.dueDateFrom).format("MM/DD/YY") === moment(getLimitDate(-3652)).format("MM/DD/YY") &&
        moment(filters.dueDateTo).format("MM/DD/YY") === moment(getLimitDate(0)).format("MM/DD/YY");
    const hasHistoricalDeposits = historicalDeposits?.length > 0;
    const [openSidebar, setOpenSidebar] = useState(false);
    const [historical, setHistorical] = useState([]);

    const openSideBarFilters = () => {
        setOpenSidebar(true);
    };

    const handleSearchHistory = () => {
        setHistorical(historicalDeposits);
    };

    useEffect(() => {
        if (noFilter) {
            setHistorical(historicalDeposits.slice(-10));
        } else {
            setHistorical(historicalDeposits);
        }
    }, [hasHistoricalDeposits]);

    if (!hasHistoricalDeposits) {
        return (
            <>
                <FilterTags openSideBarFilters={openSideBarFilters} />
                <Drawer openSidebar={openSidebar} toggleSidebar={setOpenSidebar} className="HistoricalDeposit-drawer">
                    <div className="container full-width">
                        <div className="mb-4 f-weight-b">
                            <I18n id="debin.filter" component="h2" />
                        </div>
                        <div className="text-left">
                            <HistoricalDepositsFilter
                                closeSidebar={setOpenSidebar}
                                handleSearchHistory={handleSearchHistory}
                            />
                        </div>
                    </div>
                </Drawer>
                <div className="box info service-payments__no-data">
                    <Image src="images/information_fill.svg" /> <I18n id="deposits.service.noData" />
                </div>
            </>
        );
    }

    return (
        <>
            <FilterTags openSideBarFilters={openSideBarFilters} />
            <Drawer openSidebar={openSidebar} toggleSidebar={setOpenSidebar} className="HistoricalDeposit-drawer">
                <div className="container full-width">
                    <div className="mb-4 f-weight-b">
                        <I18n id="debin.filter" component="h2" />
                    </div>
                    <div className="text-left">
                        <HistoricalDepositsFilter
                            closeSidebar={setOpenSidebar}
                            handleSearchHistory={handleSearchHistory}
                        />
                    </div>
                </div>
            </Drawer>

            <GridTable className="deposits-history-list">
                {hasHistoricalDeposits ? (
                    historical.map((rowData) => (
                        <GridTable.Container
                            className={!isDesktop && "d-flex gap-5"}
                            key={rowData.depositNumber}
                            columns={isDesktop ? 5 : 1}
                            rows={isDesktop ? 2 : 8}
                            renderAs={Link}
                            onClick={() => dispatch(depositsActions.setDepositsScreenToHistorical(true))}
                            to={`/deposits/historical/${rowData.depositNumber}`}>
                            <GridTable.Data columnStart={1} rowStart={1} alignX="flex-start" alignY="flex-start">
                                <CustomData
                                    titleText="deposits.statementId"
                                    titleTextType="I18N"
                                    titleClass="text-Primary-primary-color"
                                    valueText={rowData.depositNumber}
                                    valueTextType="STRING"
                                />
                            </GridTable.Data>
                            <GridTable.Data
                                columnStart={isDesktop ? 2 : 1}
                                rowStart={isDesktop ? 1 : 2}
                                alignX="flex-start"
                                alignY="flex-start">
                                <CustomData
                                    titleText="deposits.accreditation"
                                    titleTextType="I18N"
                                    valueText={`${rowData.accreditedAccount.productType} ${i18n.get(
                                        `currency.label.${rowData.currency}`,
                                    )} ····${rowData.accreditedAccount.number?.slice(-4)}`}
                                    valueTextType="STRING"
                                />
                            </GridTable.Data>
                            <GridTable.Data
                                columnStart={isDesktop ? 3 : 1}
                                rowStart={isDesktop ? 1 : 3}
                                alignX="flex-start"
                                alignY="flex-start">
                                <CustomData
                                    titleText="deposits.tna"
                                    titleTextType="I18N"
                                    valueText={rowData.rate}
                                    valueTextType="PERCENTAGE"
                                />
                            </GridTable.Data>
                            <GridTable.Data
                                columnStart={isDesktop ? 4 : 1}
                                rowStart={isDesktop ? 1 : 4}
                                alignX="flex-start"
                                alignY="flex-start">
                                <CustomData
                                    titleText="deposits.capitalInvested"
                                    titleTextType="I18N"
                                    valueText={rowData.amountInvested}
                                    valueTextType={rowData.currency}
                                />
                            </GridTable.Data>
                            <GridTable.Data
                                columnStart={isDesktop ? 5 : 1}
                                rowStart={isDesktop ? 1 : 5}
                                alignX="flex-start"
                                alignY="flex-start">
                                <CustomData
                                    titleText="deposits.interests"
                                    titleTextType="I18N"
                                    valueText={rowData.interest}
                                    valueTextType={rowData.currency}
                                />
                            </GridTable.Data>
                            <GridTable.Data
                                columnStart={1}
                                rowStart={isDesktop ? 2 : 6}
                                alignX="flex-start"
                                alignY="flex-start">
                                <CustomData
                                    titleText="deposits.termInDays"
                                    titleTextType="I18N"
                                    valueText={rowData.deadline}
                                />
                            </GridTable.Data>
                            <GridTable.Data
                                columnStart={isDesktop ? 2 : 1}
                                rowStart={isDesktop ? 2 : 7}
                                alignX="flex-start"
                                alignY="flex-start">
                                <CustomData
                                    titleText="deposits.creationDate.description"
                                    titleTextType="I18N"
                                    valueText={rowData.openDateFormatted}
                                    valueTextType="TEXT"
                                />
                            </GridTable.Data>
                            <GridTable.Data
                                columnStart={isDesktop ? 3 : 1}
                                rowStart={isDesktop ? 2 : 8}
                                alignX="flex-start"
                                alignY="flex-start">
                                <CustomData
                                    titleText="deposits.expirationDate.description"
                                    titleTextType="I18N"
                                    valueText={rowData.dueDateFormatted}
                                    valueTextType="TEXT"
                                />
                            </GridTable.Data>
                        </GridTable.Container>
                    ))
                ) : (
                    <EmptyScreenAlert message="echeks.service.noPending" />
                )}
            </GridTable>
        </>
    );
};

HistoricalList.propTypes = {
    historicalDeposits: instanceOf(Array),
    isDesktop: bool,
    dispatch: func.isRequired,
};

HistoricalList.defaultProps = {
    historicalDeposits: [],
    isDesktop: bool,
};

const mapStateToProps = (state) => ({
    historicalDeposits: depositsSelectors.getHistoricalDeposits(state),
    historicalDepositsFetching: depositsSelectors.getHistoricalDepositsFetching(state),
});

export default connect(mapStateToProps)(HistoricalList);
